/**
 * フォーム入力の最大文字数と切り詰め（学校名・校長名・はがき担当者名など）
 */

/** 学校名の最大文字数（学校・管理画面の入力で共通） */
export const SCHOOL_NAME_MAX_LENGTH = 20

/** 校長名の最大文字数（学校・管理画面の入力で共通） */
export const PRINCIPAL_NAME_MAX_LENGTH = 15

/** はがきに記載する職場体験担当者名の最大文字数 */
export const POSTCARD_CONTACT_PERSON_NAME_MAX_LENGTH = 15

export function clampSchoolNameInput(value: string, maxLength: number = SCHOOL_NAME_MAX_LENGTH): string {
  return value.slice(0, maxLength)
}

export function clampPrincipalNameInput(value: string, maxLength: number = PRINCIPAL_NAME_MAX_LENGTH): string {
  return value.slice(0, maxLength)
}

export function clampPostcardContactPersonNameInput(
  value: string,
  maxLength: number = POSTCARD_CONTACT_PERSON_NAME_MAX_LENGTH,
): string {
  return value.slice(0, maxLength)
}
